<template>
  <div class="sd-app-snap" >
    <sd-overlay ref="overlay" :coordinate="position_" >
      <slot :param="{isHit:isHit_,isHitVertex:isHitVertex_}">
        <div v-if="isHitVertex_" class="sd-hit sd-hit-vertex" />
        <div v-else class="sd-hit" :class="isHit_?'sd-hit-segment':'sd-miss'" />

      </slot>
    </sd-overlay>
     
  </div>
</template>

<script>
import { Snap } from 'ol/interaction';
export default {
  name: 'SdAppSnap',
  data() {
    return {
      map_:null,
      mapCtr_:null,
      isActive_:true,
      handle_:null,
      position_:null,
      snap_:null,
      isHit_:false,
      isHitVertex_:false,
      
    };
  },

  mounted() {
    
  },

  methods: {
    setMap(map,mapCtr){
      this.map_ = map
      this.mapCtr_ = mapCtr
      const ctr = this.$refs.overlay
      if (ctr) {
        ctr.setMap(map,mapCtr)
      }
    },
    getPosition(){
      return this.position_
    },
    setActive(isActive){
      this.isActive_ = isActive
    },
    setSource(source){
      if(!this.map_) return
      if (this.snap_) {
        this.map_.removeInteraction(this.snap_)
        this.snap_ = null
      }
      if(this.handle_){
        this.map_.getView().un(this.handle_.type, this.handle_.listener)
        this.handle_ = null
      }
      if (!source) {
        return
      }
      this.position_ = this.map_.getView().getCenter()
      this.snap_ = new Snap({source: source})
      this.map_.addInteraction(this.snap_)
      
      this.handle_ = this.map_.getView().on('change:center',(evt)=>{
        if (this.isActive_) {
          const pixel = this.map_.getPixelFromCoordinate(evt.oldValue)
          const result = this.snap_.snapTo(pixel, evt.oldValue,this.map_)
          this.position_ =result? result.vertex : evt.oldValue
          this.isHit_ = !!result
          this.isHitVertex_ =result? result.segment? false : true : false
        }else{
          this.position_ = evt.oldValue
        }
      })
    }
  },
};
</script>

<style scoped>
.sd-overlay {
  z-index: 100;
}
.sd-hit-vertex{
  border-radius: 0 !important;
  top: -5px !important;
}
.sd-hit{
  width: 8px;
  height: 8px;
  left: -5px;
  top: -4px;
  border-radius: 50%;
  position: absolute;
  border:1px solid rgb(0, 0, 0);
  
}

.sd-hit-segment{
  border: none !important;
}
.sd-hit-segment::before,
.sd-hit-segment::after {
    position: absolute;
    content: ' ';
    background-color: black;
    width: 1px;
    height: 100%;
}
.sd-hit-segment::before {
    transform: rotate(45deg);
}
.sd-hit-segment::after {
    transform: rotate(-45deg);
}

.sd-miss{
  width: 10px !important;
  height: 10px !important;
  left: -5px !important;
  top: -5px !important;
}
</style>
